<template>
  <div
    class="athena-search container"
    id="athena-search"
    :class="search_wildscreen ? 'search_wildscreen' : ''"
  >
    <h5
      class="title title_font2 text-uppercase"
      style="text-transform: capitalize"
    >
      {{ $t("venue.home.search") }}
    </h5>
    <div class="search-pc" style="margin-bottom: 20px; text-align: center">
      <form
        action="/search"
        @submit="subSearch"
      >
        <div class="form-group">
          <input
            type="text"
            class="form-control secondary_title"
            name="q"
            id="pwd"
            v-model="q"
            autocomplete
            :placeholder="$t('home.search_our_store')"
          />
        </div>
        <button type="submit" class="nav-search-submit">{{ $t('venue.home.search') }}</button>
      </form>
    </div>
    <div v-if="products_list.length" :class="[filter_onoff ? 'filter_flex' : '',`model_${product_list_layout}`]">
      <div
        v-if="filter_onoff"
        class="d-none d-md-block"
        :class="{
          'col-md-1-5': product_list_layout === '4columns',
          'col-md-3': product_list_layout === '3columns',
          'col-md-4': product_list_layout === '2columns',
        }"
        style="padding: 0 20px"
      >
        <v-productFilter
          :product_filter="product_filter_res"
          :api_get_product="api_get_product"
          theme="athena"
        ></v-productFilter>
      </div>
      <div class="row p-1-7d5 full-p " :class="{ 'margin-0': filter_onoff ,'product-list__box':filter_onoff}">
        <div class="list-sort col-12" style="padding: 0 17.5px">
          <v-shortSort
            :show_star="product_cart_style && product_cart_style.show_star"
            v-if="show_sort_selector"
            theme="athena"
          ></v-shortSort>
          <div class="d-block d-md-none" v-if="filter_onoff">
            <v-productFilter
              :product_filter="product_filter_res"
              :api_get_product="api_get_product"
              theme="athena"
            ></v-productFilter>
          </div>
        </div>
        <div
          v-for="list in products_list"
          :key="list.ID"
          class="p-1-7d5 p-md-1-15 full"
          :class="{
            'col-md-3 col-6': product_list_layout === '4columns',
            'col-md-4 col-6': product_list_layout === '3columns',
            'col-md-6 col-6': product_list_layout === '2columns',
          }"
        >
          <v-product-card
            theme="athena"
            :card_animate="
              product_cart_style && product_cart_style.card_animate
                ? product_cart_style.card_animate
                : 'default'
            "
            :buy_button_style="
              product_cart_style && product_cart_style.buy_button_style
            "
            :text_align="product_cart_style && product_cart_style.text_align"
            :product_price="
              product_cart_style && product_cart_style.product_price
            "
            :card_radio="product_cart_style && product_cart_style.card_radio"
            :cart_type="cart_type"
            :sales_label="product_cart_style && product_cart_style.sales_label"
            :currency_style="currency_style"
            :show_currency_selector="show_currency_selector"
            :productDetail="list"
            :layout="product_list_layout"
            :disable_select="true"
            :show_star="product_cart_style && product_cart_style.show_star"
            :sale_image="product_cart_style && product_cart_style.sale_image"
            :sale_image_show="
              product_cart_style && product_cart_style.sale_image_show
            "
            :font_size="product_cart_style && product_cart_style.font_size"
            model="is_card"
            :custom_button="
              is_custom_button &&((
              list.custom_button &&
              list.custom_button.custom_button)||(
              mix_custom_button_list &&
              mix_custom_button_list[list.ID] &&
              mix_custom_button_list[list.ID]['custom_button']))
            "
            :palette_config="palette_config"
            :product_list_layout="product_list_layout"
            :filter_onoff="filter_onoff"
            combination_position="search"
          ></v-product-card>
        </div>
      </div>
    </div>
    <div class="text-center" style="margin: 50px 0" v-else>
      <p
        style="
          font-size: 24px;
          font-weight: 600;
          line-height: 37px;
          margin-bottom: 12px;
        "
      >
        {{ $t("vogue.search.tip") }} "{{ q }}"
      </p>
      <p style="font-size: 18px; line-height: 22px">
        {{ $t("vogue.search.tip2") }}
      </p>
      <p
        class="text-uppercase"
        style="
          font-size: 24px;
          font-weight: 600;
          line-height: 37px;
          margin-bottom: 20px;
          margin-top: 40px;
        "
      >
        {{ $t("comment.recommend.tip") }}
      </p>
      <div class="row p-1-7d5">
        <div
          v-for="list in recommend_product"
          :key="list.ID"
          class="p-1-7d5 p-md-1-15"
          :class="{
            'col-md-3 col-6': product_list_layout === '4columns',
            'col-md-4 col-6': product_list_layout === '3columns',
            'col-md-1-5 col-6': product_list_layout === '5columns',
            'col-md-2 col-6': product_list_layout === '6columns',
          }"
        >
          <v-product-card
            theme="vogue"
            :card_animate="
              product_cart_style && product_cart_style.card_animate
                ? product_cart_style.card_animate
                : 'default'
            "
            :buy_button_style="
              product_cart_style && product_cart_style.buy_button_style
            "
            :text_align="product_cart_style && product_cart_style.text_align"
            :product_price="
              product_cart_style && product_cart_style.product_price
            "
            :card_radio="product_cart_style && product_cart_style.card_radio"
            :cart_type="cart_type"
            :sales_label="product_cart_style && product_cart_style.sales_label"
            :currency_style="currency_style"
            :show_currency_selector="show_currency_selector"
            :productDetail="list"
            :layout="product_list_layout"
            :disable_select="true"
            :show_star="product_cart_style && product_cart_style.show_star"
            :sale_image="product_cart_style && product_cart_style.sale_image"
            :sale_image_show="
              product_cart_style && product_cart_style.sale_image_show
            "
            :font_size="product_cart_style && product_cart_style.font_size"
            model="is_card"
            :custom_button="
              is_custom_button &&
              mix_custom_button_list &&
              mix_custom_button_list[list.ID] &&
              mix_custom_button_list[list.ID]['custom_button']
            "
            :palette_config="palette_config"
            combination_position="search"
          ></v-product-card>
        </div>
      </div>
    </div>
    <v-paging
      v-if="products_page.last_page > 1"
      :total="products_page.last_page"
      :currentPage="products_page.current_page"
      :path="products_page.path"
      :sortvalue="q"
      type="sort"
      theme="showtime"
    ></v-paging>
    <slot name="modules-list"></slot>
  </div>
</template>

<script>
// import API from "../../../../../js/API";
import vShortSort from "../../../../../js/components/view/shortSort/shortSort.vue";
import vSortSelector from "../../common/sortselector";
import vPaging from "../../../../venue/js/view/collections/Paging";
import mixFilter from "@/js/mixins/mixFilter";
import { mapActions } from "vuex";
import mixGetPlugs from "@/js/mixins/mixGetPlugs"

export default {
  props: [
    "cart_type",
    "currency_style",
    "products",
    "q",
    "show_currency_selector",
    "product_cart_style",
    "show_sort_selector",
    "product_list_layout",
    "product_filter",
    "is_custom_button",
    "palette_config",
    "recommend_product",
    "search_wildscreen",
    "product_tag",
    "comment",
    "combination_config",
  ],
  data() {
    return {
      products_page: [],
      sortvalue: "manual",
      products_list: [],
      products_ids: [],
    };
  },
  mixins: [mixFilter,mixGetPlugs],
  methods: {
    ...mapActions({
      get_product_tag: "change_product_tag_list", //获取产品tag
      get_product_palette: "get_product_palette", //获取产品调色板
      get_combination_list: "get_combination_list", // 将 `this.get_product_tag()` 映射为 `this.$store.dispatch('change_product_tag_list')`
    }),
    subSearch(){
      this.send_fb_event('Search', {search_string: this.q})
      if (window.ttq && window.send_ttp_event) {
        window.send_ttp_event('Search',{query:this.q})
      }
      //搜索时snapchat的 SEARCH 事件
      if(window.snaptr){
        window.snaptr('track', 'SEARCH',{'search_string':this.q})
      }
    }
  },
  beforeMount() {
    const url = window.location.search;
    const urlArr = url.substr(1).split("&");
    const urlObj = {};
    urlArr.forEach((item) => {
      const arr = item.split("=");
      const [key, value] = arr;
      urlObj[key] = value;
    });
    this.sortvalue = urlObj.sort || "manual";
    this.search = this.q;
    this.products_page = JSON.parse(this.products);
  },
  watch: {
    products_page: {
      handler(newV, oldV) {
        let { data } = newV;
        if (!data) {
          this.products_list = [];
          this.products_ids = [];
          return;
        }
        this.products_list = data;
        this.products_ids = [];
        data.forEach((item) => {
          this.products_ids.push(item.ID);
        });
        if (this.product_tag) {
          this.get_product_tag(this.products_ids);
        }
        if (this.combination_config) {
          this.get_combination_list({
            'filter[product_ids]': this.products_ids.join(','),
            ...this.formatSearch(),
            combination_position: "search"
          });
        }
        if (this.palette_config) {
          this.get_product_palette(this.products_ids)
        }
      },
      immediate: true,
    },
  },
  components: {
    vSortSelector,
    vPaging,
    vShortSort,
  },
};
</script>

<style lang="scss" scoped>
@media screen and(min-width: 768px) {
  .search_wildscreen {
    max-width: unset !important;
    padding-left: 50px;
    padding-right: 50px;
    .filter_flex {
      margin-right: 0;
      & > .col-md-2.d-none.d-md-block {
        width: 230px;
        flex: unset;
        margin-right: 65px;
      }
    }
  }
}
#athena-search {
  .search-pc {
    margin-bottom: 100px !important;
  }
  .title {
    font-size: 42px;
    font-weight: bold;
    color: #222222;
    line-height: 42px;
    margin-bottom: 60px;
    margin-top: 100px;
    text-align: center;
  }
  form {
    display: inline-block;
    width: 680px;
    .form-group {
      margin-bottom: 0px;
      display: inline-block;
      width: 500px;
      input {
        padding-right: 40px;
        height: 67px !important;
      }
      :-moz-placeholder {
        color: #858585;
      }

      ::-moz-placeholder {
        color: #858585;
      }
      input:-ms-input-placeholder,
      textarea:-ms-input-placeholder {
        color: #858585;
      }

      input::-webkit-input-placeholder,
      textarea::-webkit-input-placeholder {
        color: #858585;
      }
      .form-control {
        width: 100%;
        padding: 22px;
        font-style: normal;
        margin: 0;
        margin-top: 1px;
        height: 40px;
        border: 1px solid #eee;
        border-radius: 0;
        color: #858585;
        transition: background-color 0.2s ease-out;
        font-size: 24px;
      }
    }
    .nav-search-submit {
      width: 160px;
      height: 68px;
      background: #222a40;
      border-radius: 0px;
      color: #fff;
      margin-left: 15px;
      font-size: 24px;
    }
  }
  .sort-selector {
    display: inline-block;
    .select {
      width: 200px !important;
      .el-input {
        input {
          border-radius: 0 !important;
        }
      }
    }
  }
  .list-sort {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 42px;
    &::v-deep {
      .sort-select {
        .sort-select-btn {
          padding-top: 0;
        }
        .select-content {
          top: 50px;
        }
      }
    }
  }
  &::v-deep {
    .p_list_2 {
      .product_title {
        font-size: 20px !important;
        text-align: left;
        line-height: unset;
        margin-bottom: 14px;
      }
      p {
        text-align: left;
        .selectpricewrap {
          line-height: 1;
          .money {
            font-size: 20px !important;
          }
          .product_price_cross {
            float: left;
            margin-left: 0;
            font-size: 20px;
          }
        }
      }
      .ahtena_star {
        font-size: 20px;
        text-align: left;
        margin-top: 22px;
        line-height: unset;
        .starWrap {
          .el-rate__item {
            margin-right: 2px !important;
            margin-left: -4px !important;
          }
          .el-rate {
            height: auto;
          }
          .el-rate__icon {
            font-size: 29px !important;
            color: #000 !important;
          }
          .el-rate__decimal {
            font-size: 29px !important;
            color: #000 !important;
          }
        }
      }
    }
    .p_list_3 {
      .product_title {
        font-size: 20px !important;
        text-align: left;
        line-height: unset;
        margin-bottom: 14px;
      }
      p {
        text-align: left;
        .selectpricewrap {
          line-height: 1;
          .money,
          .product_price_price,
          .product_price_cross {
            font-size: 20px !important;
          }
          .product_price_cross {
            float: left;
            margin-left: 0;
            font-size: 20px;
          }
        }
      }
      .ahtena_star {
        font-size: 20px;
        text-align: left;
        margin-top: 22px;
        line-height: unset;
        .starWrap {
          .el-rate__item {
            margin-right: 2px !important;
            margin-left: -4px !important;
          }
          .el-rate {
            height: auto;
          }
          .el-rate__icon {
            font-size: 29px !important;
            color: #000 !important;
          }
          .el-rate__decimal {
            font-size: 29px !important;
            color: #000 !important;
          }
        }
      }
    }
    .p_list_4 {
      .product_title {
        font-size: 18px !important;
        text-align: left;
        line-height: unset;
        margin-bottom: 13px;
        height: unset;
      }
      p {
        text-align: left;
        .selectpricewrap {
          line-height: 1;
          .money,
          .product_price_price,
          .product_price_cross {
            font-size: 18px !important;
          }
          .product_price_cross {
            float: left;
            margin-left: 0;
          }
        }
      }
      .ahtena_star {
        font-size: 18px;
        text-align: left;
        margin-top: 20px;
        line-height: unset;
        .starWrap {
          .el-rate__item {
            margin-right: 2px !important;
            margin-left: -4px !important;
          }
          .el-rate {
            height: auto;
          }
          .el-rate__icon {
            font-size: 20px !important;
            color: #000 !important;
          }
          .el-rate__decimal {
            font-size: 20px !important;
            color: #000 !important;
          }
        }
      }
    }
    .p_list_5 {
      .product_title {
        font-size: 16px !important;
        text-align: left;
        line-height: 20px;
        margin-bottom: 13px;
        height: unset;
      }
      p {
        text-align: left;
        .selectpricewrap {
          line-height: 1;
          .money,
          .product_price_price,
          .product_price_cross {
            font-size: 16px !important;
          }
          .product_price_cross {
            float: left;
            margin-left: 0;
          }
        }
      }
      .ahtena_star {
        font-size: 16px;
        text-align: left;
        margin-top: 16px;
        line-height: unset;
        .starWrap {
          .el-rate__item {
            margin-right: 2px !important;
            margin-left: -4px !important;
          }
          .el-rate {
            height: auto;
          }
          .el-rate__icon {
            font-size: 20px !important;
            color: #000 !important;
          }
          .el-rate__decimal {
            font-size: 20px !important;
            color: #000 !important;
          }
        }
      }
    }
    .pagination {
      margin: 60px 0 100px;
      .page-item:not(:last-child) {
        margin-right: 4px;
      }
    }
    .athena_shortSort {
      display: inline;
      font-size: 20px;
      margin-bottom: 60px;
    }
    .athena_hidden,
    .athena_shortSort_mb {
      display: none;
    }
    .pc-header header h5 {
      font-size: 20px;
      margin-bottom: 21px;
      color: #222a40;
    }
    @media screen and (max-width: 768px) {
      .p_list_2,
      .p_list_3,
      .p_list_4 {
        .product_title {
          font-size: 15px !important;
          margin-bottom: 14px;
        }
        p {
          .selectpricewrap {
            .money,
            .product_price_price,
            .product_price_cross {
              font-size: 14px !important;
            }
            .product_price_cross {
              font-size: 14px;
            }
          }
        }
        .ahtena_star {
          font-size: 13px;
          margin-top: 8px;
          .starWrap {
            .el-rate__item {
              margin-right: 1px !important;
              margin-left: -1px !important;
            }
            .el-rate__icon {
              font-size: 14px !important;
            }
            .el-rate__decimal {
              font-size: 14px !important;
            }
          }
        }
      }
      .pagination {
        margin: 30px 0 50px;
        .page-item {
          font-size: 12px;
        }
      }
      .athena_shortSort {
        display: none;
      }
      .athena_shortSort_mb {
        display: inline;
      }
      .full-p {
        padding: 0 !important;
      }
      .full {
        flex: 0 0 100%;
        max-width: 100%;
        padding: 0 !important;
        > div {
          box-shadow: 0px 4px 16px 0px rgba(108, 108, 108, 0.35);
          .product_details {
            padding: 15px;
            margin-top: 0;
          }
        }
      }
    }
  }
}

.margin-0 {
  margin: 0 !important;
}

@media screen and (max-width: 768px) {
  .search_wildscreen{
    padding: 0 15px;
  }
  #athena-search {
    .search-pc {
      margin-bottom: 20px !important;
    }
    .title {
      font-size: 18px;
      margin-bottom: 25px;
      margin-top: 25px;
    }
    form {
      width: 100%;
      margin-bottom: 15px;
      display: flex;
      .form-group {
        width: 80%;
        .form-control {
          margin-top: 0;
          height: 40px !important;
          font-size: 14px;
          padding: 13.5px 15.5px;
        }
      }
      .nav-search-submit {
        width: 20%;
        margin-left: 0;
        height: 40px;
        font-size: 15px;
      }
    }
    .list-sort {
      display: flex;
      justify-content: space-between;
      margin: 20px 0 25px;
      box-shadow: 1px 1px #e3e3e3, -1px -1px #e3e3e3;
      -webkit-box-shadow: 1px 1px #e3e3e3, -1px -1px #e3e3e3;
      &::v-deep .sort-select {
        flex: 1;
        text-align: center;
        .sort-select-btn {
          padding: 13px 0;
        }
        .select-content {
          top: unset;
        }
      }
      .d-block.d-md-none {
        flex: 1;
        &::v-deep .product-filter {
          .productFileterMb {
            .filter-mb-onoff {
              .main_button {
                background-color: white !important;
                color: #333 !important;
                padding: 13px 0;
                font-size: 14px;
                font-family: Muli-Bold !important;
                line-height: 23px;
              }
            }
          }
        }
      }
      & > div:nth-child(2) {
        border-left: 1px solid #e3e3e3;
      }
    }
    .sort-selector {
      width: 100%;
      .select {
        width: 100% !important;
      }
    }
  }
}
@media screen and (min-width: 768px) {
  .filter_flex {
    display: flex;
    margin-right: -15px;
    margin-left: -15px;
    align-items: flex-start;
    & > div:last-child {
      flex: 1;
      max-width: 75%;
    }
  }
  .model_4columns{
    .product-list__box {
      max-width: 80% !important;
    }
  }
  .model_3columns{
    .product-list__box {
      max-width: 75% !important;
    }
  }
  .model_2columns{
    .product-list__box {
      max-width: 66.6666% !important;
    }
  }
}
</style>